import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from '../../../common-components/Button/Button';
import { Field, FieldType } from '../../../common-components/Field/Field';
import { If } from '../../../common-components/If/If';
import ServicesContext from '../../../contexts/ServicesContext';
import { ShopLocation } from '../../../models/ShopLocation';
import { strings } from '../../../resources/strings';
import { UpdateLocationContactInput } from '../../../services/Locations/UpdateLocationContact/UpdateLocationContactInput';
import { ContainerBody, ErrorList, Row } from '../ModalNewLocation/styles';

interface IModalLocationContactProps {
  location: ShopLocation;
  close: () => void;
  finish: () => void;
}

const ModalLocationContact: React.FC<IModalLocationContactProps> = ({
  location,
  close,
  finish
}) => {

  const { updateLocationContactService, toastService, alertService } = React.useContext(ServicesContext);

  const [emailAddress, setEmailAddress] = React.useState<string>(location.emailAddress || '');
  const [storeContactInfo, setStoreContactInfo] = React.useState<string>(location.storeContactInfo || '');
  const [storeOpeningHours, setStoreOpeningHours] = React.useState<string>(location.storeOpeningHours || '');
  const [errors, setErrors] = React.useState<string[]>([]);
  const [saving, setSaving] = React.useState<boolean>(false);

  return (
    <Modal
      show={true}
      onHide={() => close()}
      backdrop="static"
      keyboard={false}
      size='lg'
    >
      <Modal.Header>
        <Modal.Title>Contato e funcionamento — {location.name}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '78vh', overflowY: 'auto' }}>
        <ContainerBody>
          <Row>
            <Field
              type={FieldType.Email}
              label={'E-mail'}
              value={emailAddress}
              change={(value) => setEmailAddress(value)}
              autoFocus={true}
              marginTop={'0px'}
              maxLength={500}
            />
          </Row>
          <Row>
            <Field
              type={FieldType.TextArea}
              label={'Contato'}
              value={storeContactInfo}
              change={(value) => setStoreContactInfo(value)}
              marginTop={'0px'}
              maxLength={1000}
              textAreaRows={4}
            />
          </Row>
          <Row>
            <Field
              type={FieldType.TextArea}
              label={'Horário de funcionamento'}
              value={storeOpeningHours}
              change={(value) => setStoreOpeningHours(value)}
              marginTop={'0px'}
              maxLength={1000}
              textAreaRows={4}
            />
          </Row>
          <If condition={errors.length > 0}>
            <ErrorList>
              {errors.map(error => <li key={error}>{error}</li>)}
            </ErrorList>
          </If>
        </ContainerBody>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button text={strings.Cancel} click={() => close()} marginRight={'10px'} disabled={saving} />
          <Button text={strings.Save} click={() => save()} marginLeft={'10px'} disabled={saving} />
        </div>
      </Modal.Footer>
    </Modal>
  );

  function save() {
    const input = new UpdateLocationContactInput();
    input.id = location.id;
    input.emailAddress = emailAddress.trim() || null;
    input.storeContactInfo = storeContactInfo.trim() || null;
    input.storeOpeningHours = storeOpeningHours.trim() || null;

    setErrors([]);
    setSaving(true);
    updateLocationContactService.handle(input)
      .then(result => {
        if (result?.value?.result) {
          toastService.success('Contato e funcionamento atualizados.');
          finish();
          return;
        }
        setErrors(result?.value?.errors?.length ? result.value.errors : ['Não foi possível salvar a loja.']);
      })
      .catch(error => {
        if (error?.response) {
          toastService.warning(strings.OpsSomethingWrongSendTheData);
        } else {
          alertService.warning(strings.TheServerIsNotRespondingRefreshListAndTryAgain);
        }
      })
      .finally(() => setSaving(false));
  }
}

export { ModalLocationContact };
